export default {
    filters: {
        formatEur(eur){
            return eur.toFixed(2);
        },
        formatEurWithSymbol(eur){
            return eur.toFixed(2) + '€';
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/filters.js